// DOM取得
const tabMenus = document.querySelectorAll(".p-top-topics__category li");

// イベント付加
tabMenus.forEach((tabMenu) => {
  tabMenu.addEventListener("click", tabSwitch);
});
// イベントの処理
function tabSwitch(e) {
  // クリックされた要素のデータ属性を取得
  const tabTargetData = e.currentTarget.dataset.tab;

  // クリックされた要素の親要素と、その子要素を取得
  const tabList = e.currentTarget.closest(".p-top-topics__category");
  const tabItems = tabList.querySelectorAll(".p-top-topics__category li");

  // クリックされた要素の親要素の兄弟要素の子要素を取得
  const tabPanelItems = tabList.nextElementSibling.querySelectorAll(
    ".p-top-topics__container"
  );

  // タブの切り替え
  tabItems.forEach((tabItem) => {
    tabItem.classList.remove("current");
  });

  tabPanelItems.forEach((tabPanelItem) => {
    tabPanelItem.classList.remove("current");
  });

  // クリックされたtabにクラスを付与
  e.currentTarget.classList.add("current");

  // アニメーションを完了してから次のタブを表示
  tabPanelItems.forEach((tabPanelItem) => {
    if (tabPanelItem.dataset.panel === tabTargetData) {
      tabPanelItem.classList.add("current");
    }
  });
}
